
<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">為替レート詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_ER_NEW>{{$t('app.buttons.save')}}</v-btn>
        <v-btn @click="$router.go(-1)">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>

      <v-form v-model="valid">
        <v-container fluid>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :rules="[v=> !!v || `外貨名 is required`]"
                label="外貨名"
                url="currencies/kv"
                v-model="form.currencyCode"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :rules="[v=> !!v || `レート is required`]"
                clearable
                label="レート"
                v-model="form.rate"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :rules="[v=> !!v || `レート区分 is required`]"
                label="レート区分"
                url="exchange-rate-scopes/kv"
                v-model="form.scopeId"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <date-picker
                :rules="[v=> !!v || `適用開始日 is required`]"
                label="適用開始日"
                v-model="form.startDate"
              ></date-picker>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <date-picker
                :min="form.startDate"
                :rules="[v=> !!v || `適用終了日 is required`]"
                label="適用終了日"
                url="countries/kv"
                v-model="form.endDate"
              ></date-picker>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      valid: true,
      form: {
        name: null
      },
      nameRules: [v => !!v || 'Name is required']
    }
  },
  computed: {
    minEndDate() {
      let startDate = this.form.startDate || ''
      let now = new Date().format('yyyy-MM-dd')
      if (startDate.localeCompare(now) > 0) {
        return startDate
      }
      return now
    }
  },
  methods: {
    save() {
      this.$http
        .post('/exchange-rates', this.form)
        .then(() => {
          this.$router.go(-1)
        })
        .catch(err => this.$catch(err))
    }
  }
}
</script>
